'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Detail = require('../Detail/Detail');

var _Detail2 = _interopRequireDefault(_Detail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShippingAddress = function ShippingAddress(props) {
  var title = props.title,
      userData = props.userData;
  var shippingAddress = userData.shippingAddress;
  var shipFirstName = shippingAddress.shipFirstName,
      shipLastName = shippingAddress.shipLastName,
      shipAddress1 = shippingAddress.shipAddress1,
      shipAddress2 = shippingAddress.shipAddress2,
      shipCity = shippingAddress.shipCity,
      shipState = shippingAddress.shipState,
      shipZipCode = shippingAddress.shipZipCode;

  return _react2.default.createElement(
    _Detail2.default,
    { icon: 'fa-home', title: title },
    _react2.default.createElement(
      'p',
      { className: 'desc mar-0' },
      shipFirstName,
      ' ',
      shipLastName
    ),
    _react2.default.createElement(
      'p',
      { className: 'desc mar-0' },
      shipAddress1
    ),
    _react2.default.createElement(
      'p',
      { className: 'desc mar-0' },
      shipAddress2
    ),
    _react2.default.createElement(
      'p',
      { className: 'desc mar-0' },
      shipCity,
      ', ',
      shipState
    ),
    _react2.default.createElement(
      'p',
      { className: 'desc mar-0' },
      shipZipCode
    )
  );
};

exports.default = ShippingAddress;

//# sourceMappingURL=ShippingAddress.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bit/fabfitfun.shared.global.layout-reader/node_modules/@bit/fabfitfun.my-box.global.my-box-header/dist/ShippingAddress/ShippingAddress.js
// module id = 593
// module chunks = 0